<tt-page>
    <ng-container *ngIf="'mobile' | mediaQuery">
        <ng-container *ngTemplateOutlet="list"></ng-container>
    </ng-container>

    <ng-container *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="selectcity_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="50">
                    <ng-container *ngTemplateOutlet="list"></ng-container>
                </tt-divider-pane>

                <tt-divider-pane ttSize="50"></tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </ng-container>
</tt-page>

<p *ngIf="error" role="alert">{{ error }}</p>

<ng-template #list>
    <ng-container>
        <tt-card>
            <form (ngSubmit)="search()">
                <tt-input ttLabel="city_search" ttType="search" ttBindFocus [(ttModel)]="searchText">
                    <ng-container buttons>
                        <tt-form-field-button ttId="erase" ttIcon="fas fa-eraser" ttType="danger" (ttClick)="clearSearch()"></tt-form-field-button>
                        <tt-form-field-button ttIcon="fas fa-search" [ttLoading]="loading" (ttClick)="search()"></tt-form-field-button>
                    </ng-container>
                </tt-input>
            </form>
        </tt-card>

        <tt-list [ttData]="items" ttBackStyle [ttGoto]="false" (ttClick)="select($event.item)"></tt-list>
    </ng-container>
</ng-template>
